import { EnrichedResourceFileObject, Resource, ResourceType } from 'types';

export const handleDownload = (
  resource: Resource | EnrichedResourceFileObject,
) => {
  if (
    resource.resourceType === ResourceType.CERTIFICATE &&
    resource.fileContent !== null
  ) {
    const base64String = resource.fileContent;
    try {
      // Decode base64 string to binary
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      // Create a blob and download
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = resource.description;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download failed:', error);
    }
  } else {
    window.open(resource.url, '_blank');
  }
};
